if(!customElements.get('quantity-selector')){
    class QuantitySelector extends HTMLElement {
        constructor(){
            super();

            this.currentQuantitySize = parseInt(this.dataset.quantitySize);
            this.buttonAdd = this.querySelector('.button-plus');
            this.buttonRemove = this.querySelector('.button-minus');
            this.input = this.querySelector('input[name="quantity"]');

            this.buttonAdd.addEventListener("click", this.add.bind(this));
            this.buttonAdd.addEventListener("keydown", e => { if(e.key === 'Enter'){ this.add(e); }});

            this.buttonRemove.addEventListener("click", this.remove.bind(this));
            this.buttonRemove.addEventListener("keydown", e => { if(e.key === 'Enter'){ this.remove(e); }});

            this.currentProductVariantId = this.dataset.productVariantId;
            
            this.quantityWrapper = this.closest('.quantity-wrapper');
            this.volumnPricing = this.quantityWrapper?.querySelector('volumn-pricing');
            if(this.volumnPricing){
                this.initializeVolumnPricing();
            }

            // update input value to only number
            this.input.addEventListener("input", (e) => {
                let currentQuantitySize = e.target.value.replace(/[^0-9]/g, '');
                if(currentQuantitySize.trim() == "" || parseInt(currentQuantitySize) < 0){
                    currentQuantitySize = 1;
                } else {
                    currentQuantitySize = parseInt(currentQuantitySize);
                }
                e.target.value = currentQuantitySize;
            });

            // update quantity when input value change
            this.input.addEventListener("change", (e) => {
                const inputValue = parseInt(e.target.value) || 0;
                if(inputValue < 0){
                    e.target.value = 0;
                    return;
                }

                e.target.value = inputValue;

                this.currentQuantitySize = e.target.value;
                this.updateQuantity();
            });
        }

        connectedCallback(){
            this.exceedAvailableQuantityUnsubscriber = PubSub.subscribe(PubSub.events.exceedAvailableQuantity, (event) => {
                if(event.productVariantId.toString() === this.currentProductVariantId){
                    this.input.value = "1";
                    this.input.setAttribute("value", "1");
                    
                    this.currentQuantitySize = "1";
                    this.updateQuantity();
                }
            });
        }

        disconnectedCallback() {
            if (this.exceedAvailableQuantityUnsubscriber && typeof this.exceedAvailableQuantityUnsubscriber === 'function') {
                this.exceedAvailableQuantityUnsubscriber();
            }
        }

        initializeVolumnPricing(){
            this.buttonShowMore = this.volumnPricing.querySelector('.button-show-more');
            this.volumnPricingItems = this.volumnPricing.querySelectorAll('li');
            if(this.buttonShowMore){
                this.buttonShowMore.addEventListener("click", () => {
                    this.volumnPricingItems.forEach(item => {
                        item.setAttribute('aria-hidden', 'false');
                    });

                    this.buttonShowMore.remove();
                });
            }
        }

        add(){
            if(!this.currentQuantitySize) return;
            if(this.input.value.trim() == "" || parseInt(this.input.value) < 0){
                this.currentQuantitySize = 1;
                return;
            }

            this.currentQuantitySize = parseInt(this.currentQuantitySize) + 1;
            this.updateQuantity();
        }

        remove(){
            if(!this.currentQuantitySize) return;
            if(this.input.value.trim() == "" || parseInt(this.input.value) < 0){
                this.currentQuantitySize = 1;
                return;
            }
            
            this.currentQuantitySize = parseInt(this.currentQuantitySize) - 1;
            this.updateQuantity();
        }

        updateQuantity(){
            if(this.currentQuantitySize < 1) this.currentQuantitySize = 1;
            this.input.value = this.currentQuantitySize;
            this.input.setAttribute("value", this.currentQuantitySize);
            this.setAttribute('data-quantity-size', this.currentQuantitySize);
        }
    }

    customElements.define('quantity-selector', QuantitySelector);
}